import CartOrderSummary from './CartOrderSummary';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import { deletePromoCode } from 'src/client/js/store/thunks/cart';
import { replaceTextWithValues } from 'src/common/utils/text-replace';

const enhance = compose(
  connect(
    null,
    dispatch => ({
      deletePromoCode: () => dispatch(deletePromoCode()),
    }),
  ),
  withProps(props => {
    const values = { quantity: props.itemCount };
    return {
      label: {
        ...props.label,
        itemTotal: replaceTextWithValues(props.label.itemTotal, values),
        discountedTotal: replaceTextWithValues(props.label.discountedTotal, values),
      },
    };
  }),
  withHandlers({
    onRemoveCode: props => () => props.deletePromoCode(),
  }),
);

export default enhance(CartOrderSummary);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartSummary/CartOrderSummary/index.js